import {Injectable} from '@angular/core';
import {AuthService} from '../auth.service';
import {AppConstants} from '../shared/app.constants';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class BrandService {

  constructor(private auth: AuthService, private appConstants: AppConstants, private http: HttpClient) {
  }

  getAllBrands(): Observable<any> {
    const url = environment.apiBase + 'all_brands';
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  getBrand(brandId): Observable<any> {
    const url = environment.apiBase + `brands/${brandId}`;
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  getBrandManagers(): Observable<any> {
    const url = environment.apiBase + 'brandmanagers';
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

  createBrand(body): Observable<any> {
    const url = environment.apiBase + 'brands';
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.post(url, body, headers).map(res => res).catch(this.appConstants.errorHandler);
  }

  updateBrand(body): Observable<any> {
    const url = environment.apiBase + `brands/${body.id}`;
    const headers = {headers: this.auth.getAuthorizationHeaders()};
    return this.http.put(url, body, headers).map(res => res).catch(this.appConstants.errorHandler);
  }

}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/brands/brand.service.ts